import { createTheme } from '@mui/material/styles';

export function getOverlayContainer() {
  if (typeof document === 'undefined') return undefined;
  // Keep nested portals inside the Bootstrap focus trap.
  return document.activeElement?.closest?.('.modal[role="dialog"]') || document.body;
}

export const muiTheme = createTheme({
  components: {
    MuiMenu: { defaultProps: { transitionDuration: {enter: 160, exit: 120} } },
    MuiPopover: { defaultProps: { container: getOverlayContainer, transitionDuration: {enter: 160, exit: 120} } },
    MuiDialog: { defaultProps: { container: getOverlayContainer, transitionDuration: {enter: 180, exit: 120} } },
    MuiModal: { defaultProps: { container: getOverlayContainer } },
    MuiPopper: { defaultProps: { container: getOverlayContainer } },
    MuiInputBase: {
      defaultProps: { disableInjectingGlobalStyles: true },
    },
  },
});

export const inputAutofillStyles = {
  '@keyframes mui-auto-fill': { from: { display: 'block' } },
  '@keyframes mui-auto-fill-cancel': { from: { display: 'block' } },
};
